import React from 'react';

// Modal names for consistent referencing
export const MODAL_NAMES = {
  PRICE_PAID: 'pricePaidModal',
  DELIVERY_FEE: 'deliveryFeeModal',
  TOTAL_PRICE_PAID: 'totalPricePaidModal',
  PLATFORM_COMMISSION: 'platformCommissionModal',
  TRANSACTION: 'transactionModal',
  OTHER_FEE_ONE: 'otherFeeOneModal',
  OTHER_FEE_TWO: 'otherFeeTwoModal',
  PLATFORM_DELIVERY_FEE: 'platformDeliveryFeeModal',
  PRODUCT_PRICE_RETURN_WINDOW: 'productPriceReturnWindowModal',
  DELIVERY_FEE_RETURN_WINDOW: 'deliveryFeeReturnWindowModal',
  PRODUCT_PRICE_RETURN_PROCESSING: 'productPriceReturnProcessingModal',
  DELIVERY_FEE_RETURN_PROCESSING: 'deliveryFeeReturnProcessingModal',
  REFUNDED_TO_CUSTOMER: 'refundedToCustomerModal',
  COMMISSION_REFUNDED: 'commissionRefundedModal',
  TRANSACTION_FEE_REFUNDED: 'transactionFeeRefundedModal',
  OTHER_FEE_ONE_REFUNDED: 'otherFeeOneRefundedModal',
  OTHER_FEE_TWO_REFUNDED: 'otherFeeTwoRefundedModal',
} as const;

// API search values
export const SEARCH_VALUES = {
  PRICE_PAID_BY_CUSTOMER: 'price_paid_by_customer',
  DELIVERY_FEE_PAID_BY_CUSTOMER: 'delivery_fee_paid_by_customer',
  PLATFORM_COMMISSION: 'platfrom_commission',
  TRANSACTION_FEES: 'transaction_fees',
  HANDLING_CHARGES: 'handling_charges',
  OTHER_FEES: 'other_fees',
  DELIVERY_FEES: 'delivery_fees',
  SALE_UNDER_RETURN_WINDOW: 'sale_under_return_window',
  SALE_UNDER_RETURN_WINDOW_DELIVERY: 'sale_under_return_window_delivery',
  SALE_UNDER_PROCESSING: 'sale_under_processing',
  SALE_UNDER_PROCESSING_DELIVERY: 'sale_under_processing_delivery',
  REFUND_PAID_TO_CUSTOMER: 'refund_paid_to_customer',
  REFUND_PLATFORM_COMMISSION: 'refund_platfrom_commission',
  REFUND_TRANSACTION_FEES: 'refund_transaction_fees',
  REFUND_HANDLING_CHARGES: 'refund_handling_charges',
  REFUND_OTHER_FEES: 'refund_other_fees',
} as const;

// Table column configurations
export interface TableColumn {
  key: string;
  label: string;
  render?: (value: any, order: any) => React.ReactNode;
}

export const TABLE_COLUMNS: Record<string, TableColumn[]> = {
  BASIC_ORDER: [
    { key: 'order', label: 'Order No' },
    { key: 'order_details', label: 'Order Details' },
    { key: 'item_name', label: 'Items Name' },
    { key: 'unit', label: 'Unit' },
    { key: 'rate', label: 'Rate' },
    { key: 'total', label: 'Total' },
    { key: 'status', label: 'Status' },
  ],
  DELIVERY_FEE: [
    { key: 'order', label: 'Order No' },
    { key: 'order_details', label: 'Order Details' },
    { key: 'item_name', label: 'Item Name' },
    { key: 'unit', label: 'Unit' },
    { key: 'commission_name', label: 'Commission Name' },
    { key: 'uom', label: 'UOM' },
    { key: 'rate', label: 'Rate' },
    { key: 'total', label: 'Total' },
  ],
  COMMISSION: [
    { key: 'order', label: 'Order No' },
    { key: 'order_details', label: 'Order Details' },
    { key: 'item_name', label: 'Items Name' },
    { key: 'unit', label: 'Unit' },
    { key: 'uom', label: 'UOM' },
    { key: 'rate', label: 'Rate', render: (value: string) => `${value}%` },
    { key: 'total', label: 'Product Price Total' },
    { key: 'percentage_amount', label: 'Commission' },
  ],
  TRANSACTION_FEE: [
    { key: 'order', label: 'Order No' },
    { key: 'order_details', label: 'Order Details' },
    { key: 'item_name', label: 'Items Name' },
    { key: 'unit', label: 'Unit' },
    { key: 'total', label: 'Product Price Total' },
    { key: 'status', label: 'Status' },
    { key: 'commission_name', label: 'Commission Name' },
    { key: 'uom', label: 'UOM' },
    { key: 'rate', label: 'Rate', render: (value: string) => `${value}%` },
    { key: 'percentage_amount', label: 'Commission' },
  ],
};

// Tab keys
export const TAB_KEYS = {
  WEEKLY: 'home',
  CUSTOM_DATES: 'profile',
} as const;

export type ModalName = keyof typeof MODAL_NAMES;
export type SearchValue = typeof SEARCH_VALUES[keyof typeof SEARCH_VALUES];
export type TabKey = typeof TAB_KEYS[keyof typeof TAB_KEYS];